/* unplugin-vue-components disabled */import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "bottomSeatBg"
};
const _hoisted_3 = {
  class: "footer-container"
};
const _hoisted_4 = {
  class: "substance"
};
const _hoisted_5 = {
  class: "substance-svg"
};
const _hoisted_6 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "navigation"
};
const _hoisted_7 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "navigation"
};
const _hoisted_8 = {
  class: "substance-svg"
};
const _hoisted_9 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "navigation"
};
const _hoisted_10 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "navigation"
};
import TopNav from '@/components/TopNav';
export default {
  __name: 'Footer',
  setup(__props) {
    const state = ref(true);
    function onChange() {
      state.value = !state.value;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", {
        class: "mask",
        onClick: onChange
      }, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(TopNav), {
        id: "topmenu-container",
        class: "topmenu-container"
      })])], 512), [[_vShow, _unref(state) === false]]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "substance-box",
        onClick: onChange
      }, [_createElementVNode("div", _hoisted_5, [!_unref(state) ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[0] || (_cache[0] = [_createElementVNode("path", {
        d: "M36 12L24 24L12 12",
        stroke: "#83E9FF",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1), _createElementVNode("path", {
        d: "M36 24L24 36L12 24",
        stroke: "#83E9FF",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[1] || (_cache[1] = [_createElementVNode("path", {
        d: "M12 24L24 12L36 24",
        stroke: "#83E9FF",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1), _createElementVNode("path", {
        d: "M12 36L24 24L36 36",
        stroke: "#83E9FF",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)]))]))]), _cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "substance-text"
      }, "系统导航", -1)), _createElementVNode("div", _hoisted_8, [!_unref(state) ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[2] || (_cache[2] = [_createElementVNode("path", {
        d: "M36 12L24 24L12 12",
        stroke: "#83E9FF",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1), _createElementVNode("path", {
        d: "M36 24L24 36L12 24",
        stroke: "#83E9FF",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[3] || (_cache[3] = [_createElementVNode("path", {
        d: "M12 24L24 12L36 24",
        stroke: "#83E9FF",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1), _createElementVNode("path", {
        d: "M12 36L24 24L36 36",
        stroke: "#83E9FF",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)]))]))])])])])]);
    };
  }
};